export enum EFooterMenuCategory {
  KANZI = 'Kanzi',
  PRODUCT = 'Product',
  LEGAL = 'Legal',
}
